module.exports = __webpack_public_path__ + "static/media/exercises.0cd146f2.svg";